import styled from 'styled-components';

import {Switch} from "@chakra-ui/react";
import {useStoreProfile} from "../../../store";
import FormContainer from "../../../components/form_container";
import {WhiteMain} from "../../../components/main";
import {FixedTopBar} from "../../../components/top_bar";
import {themecolors} from "../../../utils/themecolors";
import {useActions} from "../../../app_context";

const SwitchHeading = styled.div``;
const SwitchDescription = styled.div``;
const SwitchContainer = styled.div``
const SwitchText = styled.div``;
const SwitchItem = styled.div``;

const AppearanceSettings = styled(({className}) => {

    const actions = useActions();
    const settings = useStoreProfile();
    const apply = async (changes) => {
        await actions.settingsChanged(changes);
    };

    return (
        <>
            <FixedTopBar back title="Appearance" border={false}/>
            <WhiteMain className={className}>
                <FormContainer>

                    <SwitchContainer>
                        <SwitchText>
                            <SwitchHeading>Dark Mode</SwitchHeading>
                            <SwitchDescription>
                                The platform will appear darker.
                            </SwitchDescription>
                        </SwitchText>
                        <SwitchItem>
                            <Switch isChecked={settings.theme === "dark"}
                                    onChange={(value) => apply({theme: settings.theme === "dark" ? "light" : "dark"})} />
                        </SwitchItem>
                    </SwitchContainer>

                </FormContainer>
            </WhiteMain>
        </>
    );
})`
  ${FormContainer} {
    background-color: ${({theme}) => theme.color.name === 'dark' ? 'transparent' : theme.white_0};
    padding: 16px 20px;
  }

  ${SwitchDescription} {
    color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_medium_impact_text : 'rgb(89, 96, 104)'};
    font-size: 13px;
  }

  ${SwitchContainer} {
    width: 450px;
    max-width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 16px;
  }

  ${SwitchHeading} {
    font-weight: 600;
    font-size: 14px;
  }

  ${SwitchItem} {
    margin-left: auto;
  }
`;

export default AppearanceSettings;
